module.exports = __webpack_public_path__ + "img/BodegaAurrera.1983f5f6.png";